/**
 * 八字四柱極簡迷你圖。
 *
 * Phase 1：只渲染年柱/月柱/日柱/時柱的「天干地支」標籤（沒真算命盤）。
 * Week 10 會接 worker-astro 的 /compute/natal 拿真實值。
 */

interface Pillar {
  label: string; // 年 / 月 / 日 / 時
  stem: string | null; // 天干（甲乙丙丁⋯）
  branch: string | null; // 地支（子丑寅卯⋯）
}

interface BaziMiniChartProps {
  pillars?: Pillar[];
}

const DEFAULT_PILLARS: Pillar[] = [
  { label: '年', stem: null, branch: null },
  { label: '月', stem: null, branch: null },
  { label: '日', stem: null, branch: null },
  { label: '時', stem: null, branch: null },
];

export function BaziMiniChart({ pillars = DEFAULT_PILLARS }: BaziMiniChartProps) {
  return (
    <div className="rounded-lg border border-paper bg-cream/60 p-3">
      <h3 className="mb-2 text-xs font-medium text-ink/60">八字</h3>
      <div className="grid grid-cols-4 gap-1 text-center">
        {pillars.map((p) => (
          <div key={p.label} className="flex flex-col items-center gap-0.5">
            <span className="text-[10px] text-ink/40">{p.label}</span>
            <span className="font-serif text-sm font-bold">{p.stem ?? '—'}</span>
            <span className="font-serif text-sm">{p.branch ?? '—'}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
